import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { trigger, transition, style, animate, state } from '@angular/animations';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UserService } from './services/user/user.service';
import { DataService } from './services/data/data.service';
import { DisplayService } from './services/display/display.service';
import { ConfigService } from './services/config/config.service';
import { NotificationService } from './services/notification/notification.service';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { NoteService } from './services/note/note.service';
import { IconService } from 'carbon-components-angular';
import { UserAvatar20, Menu20, Time20, Add20, ArrowRight20, Download16 } from '@carbon/icons';

@Component({
	selector: 'pcm-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'] //,
	// animations: [
	// 	trigger(
	// 		'enterAnimation',
	// 		[
	// 			transition(
	// 				':enter', [
	// 					style({ transform: 'translateX(0)', 'opacity': 0 }),
	// 					animate('500ms', style({ transform: 'translateX(0)', 'opacity': 1 }))
	// 				]
	// 			),
	// 			transition(
	// 				':leave', [
	// 					style({ transform: 'translateX(0)', 'opacity': 1 }),
	// 					animate('500ms', style({ transform: 'translateX(0)', 'opacity': 0 }))
	// 				]
	// 			)
	// 		]
	// 	)
	// ]
})
export class AppComponent implements OnInit {

	idleState = 'Not started.';
	timedOut = false;
	lastPing?: Date = null;
	private messages = [];
	private icons = [UserAvatar20, Menu20, Time20, Add20, ArrowRight20, Download16];
	
	constructor(
		private router: Router,
		private route: ActivatedRoute,
		public userService: UserService,
		public dataService: DataService,
		public displayService: DisplayService,
		public configService: ConfigService,
		private notificationService: NotificationService,
		private idle: Idle, private keepalive: Keepalive,
		private noteService: NoteService,
		private iconService: IconService
	) {

		// sets an idle timeout of 300 seconds or 5 min, for testing purposes.
		idle.setIdle(30000);
		// sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
		idle.setTimeout(5);
		// sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
		idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

		idle.onIdleEnd.subscribe(() => this.idleState = 'No longer idle.');
		idle.onTimeout.subscribe(() => {
		this.idleState = 'Timed out!';
		this.timedOut = true;
		this.router.navigate(['/logout']);
		});
		idle.onIdleStart.subscribe(() => {
			this.idleState = 'You\'ve gone idle!';
			if (this.router.url !== '/login') {
				this.noteService.displayWarning(this.idleState);
			}
		});
		idle.onTimeoutWarning.subscribe((countdown) => {
				this.idleState = 'You will time out in ' + countdown + ' seconds!';
				if (this.router.url !== '/login') {
					this.noteService.displayWarning(this.idleState, true);
				}
			});

		// sets the ping interval to 15 seconds
		keepalive.interval(15);

		keepalive.onPing.subscribe(() => this.lastPing = new Date());

		this.reset();
		}

		reset() {
			this.idle.watch();
			this.idleState = 'Started.';
			this.timedOut = false;
		}

	ngOnInit() {
		const self = this;
		window.onresize = function () {
			self.displayService.calcSize(self.displayService);
		};
		self.displayService.calcSize(self.displayService);

		// register icons for carbon icons ("ibmIcon")
		this.iconService.registerAll(this.icons);
		
	}

	clickLeft(event) {
		const currentRoute = this.router.routerState.snapshot.url;
		if (currentRoute.indexOf('/timesheet/') > -1) {
			this.router.navigateByUrl('timesheets');
		}
		this.displayService.collapseLeft();
	}

	isPublicPage() {
		const routerURL = this.router.url;
		if (routerURL.indexOf('accept-account') > -1 || routerURL.indexOf('login-help') > -1) {
			return true;
		}
		return false;
	}

}
